import React from "react";
import { Controller, Control } from "react-hook-form";
import { FormGroup, Input } from "@cofano/cck";
import LocationSelect from "view/locations/components/selects/LocationSelect";
import { Language } from "imports/Utils";
import { CargoForm } from "types/index";

const VoyageSchedule = ({ control }: {
	control: Control<CargoForm>,
}) => {
	return (
		<React.Fragment>
			<FormGroup label={Language("CARGO_PREVIOUS_INLAND_TERMINAL")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="previousInlandTerminal"
					control={control}
					render={({ field }) => <LocationSelect {...field} />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_NEXT_INLAND_TERMINAL")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="nextInlandTerminal"
					control={control}
					render={({ field }) => <LocationSelect {...field} />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_PREVIOUS_PORT")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="previousPort"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_NEXT_PORT")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="nextPort"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_FINAL_PORT")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="finalPort"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>
		</React.Fragment>
	);
};

export default VoyageSchedule;
